import { useState, useEffect, MouseEvent } from 'react'

interface IOverlayArgs {
  onCloseCallback?: (identifier: string) => void
}

interface IOverlayReturn {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void
  onClose: (event: MouseEvent<HTMLButtonElement> | null, identifier: string) => void
  open: boolean
  id: string | undefined
  anchorEl: HTMLButtonElement | null
}

/**
 * Custom hook to manage the state of the overlay
 * - onCloseCallback: useful for clearing out selected values in the state of an overlay.
 */
export const useOverlay = (args: IOverlayArgs = {}): IOverlayReturn => {
  const { onCloseCallback } = args
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  useEffect(() => {
    window.onpopstate = (_e: any) => {
      setAnchorEl(null)
    }
  })

  const onClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const onClose = (_event: MouseEvent<HTMLButtonElement> | null, identifier = 'cancel') => {
    setAnchorEl(null)
    if (onCloseCallback) {
      onCloseCallback(identifier)
    }
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return {
    onClick,
    onClose,
    open,
    id,
    anchorEl,
  }
}
